import { FeedbackInteractionRequest } from "@amzn/afxtaco-types";
import { apiPost } from "../apiUtils";

/**
 * API response wrapper for interaction feedback
 */
export interface InteractionResponse {
  success: boolean;
  data: {
    message: string;
  };
}

/**
 * Submits user feedback interaction to the backend
 *
 * @param feedbackRequest - Feedback data including simple and/or detailed feedback
 * @returns Promise resolving to success confirmation
 * @throws Error if the API request fails or returns invalid data
 *
 * @example
 * ```typescript
 * // Simple feedback only
 * const response = await postInteraction({
 *   simpleFeedback: "THUMBS_UP"
 * });
 *
 * // Detailed feedback
 * const response = await postInteraction({
 *   simpleFeedback: "THUMBS_DOWN",
 *   detailedFeedback: {
 *     feedbackReason: "Inaccurate response",
 *     sectionalFeedback: {
 *       section1: "Good",
 *       section2: "Needs improvement"
 *     }
 *   }
 * });
 * console.log(response.data.message);
 * ```
 */
export const postInteraction = async (
  feedbackRequest: FeedbackInteractionRequest,
): Promise<InteractionResponse> => {
  const restOperation = apiPost("/interaction", feedbackRequest);

  const { body } = await (await restOperation).response;
  return (await body.json()) as unknown as InteractionResponse;
};
